export default "__VITE_ASSET__D9gA0Wiq__"